import CourierSurveyScreen from "./CourierSurveyScreen";

export default CourierSurveyScreen;
